import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";

const NoDataWithCTAWrapperContainer = styled.div`
    background-color: white;
    width: 100%;
    height: 300px;
    padding-top: 20px;
`;

const NoDataContainer = styled(FlexColumn)`
    align-items: center;
    padding: 50px 0;
`;

const NoDataTextPrimary = styled.span`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])}
    margin: 16px 0 8px 0;
    text-align: center;
`;
const NoDataTextSecondary = styled.span`
    ${setFontVariant("listItem3", colorsPalettes.carbon[300])};
`;

const ImageStyle = styled.div`
    height: 84px;
    width: 160px;
`;

export const KeywordGeneratorToolNoDataForLargeKeyword = () => {
    return (
        <NoDataWithCTAWrapperContainer>
            <NoDataContainer>
                <ImageStyle>
                    <SWReactIcons iconName={"no-data-lab"} />
                </ImageStyle>
                <NoDataTextPrimary
                    dangerouslySetInnerHTML={{
                        __html: translate("keyword.generator.error.message.limit.words.in.keyword"),
                    }}
                ></NoDataTextPrimary>
            </NoDataContainer>
        </NoDataWithCTAWrapperContainer>
    );
};
